export default "__VITE_ASSET__DgIilgBy__"